import Axios from "axios";
import { Modal } from "antd";
import { API_ADDRESS } from "..";
import { GetToken } from "../helper";

export interface ChassisStock {
  id: number;
  production_unit: string;
  type: string;
  brand: string;
  location: string;
  tank_size: number;
  fan_type?: string;
  arm_type?: string;
  quantity: number;
  is_active: boolean;
}

export interface ArmStock {
  id: number;
  brand: string;
  location: string;
  arm_type: string;
  arm_length: string;
  meme_distance: string;
  meme_type: string;
  quantity: number;
  is_active: boolean;
}

export interface TankStock {
  id: number;
  brand: string;
  caldron_color: string;
  location: string;
  tank_size: number;
  caldron_type: string;
  quantity: number;
  is_active: boolean;
}

export interface ChassisStockUpsertRequest {
  id?: number;
  production_unit: string;
  type: string;
  brand: string;
  location: string;
  tank_size: number;
  fan_type?: string;
  arm_type?: string;
  quantity: number;
}

export interface ArmStockUpsertRequest {
  id?: number;
  brand: string;
  location: string;
  arm_type: string;
  arm_length: string;
  meme_distance: string;
  meme_type: string;
  quantity: number;
}

export interface TankStockUpsertRequest {
  id?: number;
  brand: string;
  caldron_color: string;
  location: string;
  tank_size: number;
  caldron_type: string;
  quantity: number;
}

export interface StockTransferRequest {
  source_stock_id: number;
  target_location: string;
  quantity: number;
}

async function getRequest<T>(path: string): Promise<T[]> {
  return Axios.get(`${API_ADDRESS}/api/Stock/${path}`, {
    headers: {
      Authorization: "Bearer " + GetToken(),
    },
  })
    .then((res) => res.data)
    .catch(() => {
      Modal.error({
        title: "Hata",
        content: <p>Stok verileri alınırken bir hata oluştu.</p>,
        okText: "Tamam",
      });
      return [];
    });
}

async function postRequest(path: string, payload: unknown): Promise<boolean> {
  return Axios.post(`${API_ADDRESS}/api/Stock/${path}`, payload, {
    headers: {
      Authorization: "Bearer " + GetToken(),
    },
  })
    .then(() => true)
    .catch((err) => {
      Modal.error({
        title: "Hata",
        content: (
          <p>
            {err?.response?.data?.message ||
              "Stok kaydı sırasında bir hata oluştu."}
          </p>
        ),
        okText: "Tamam",
      });
      return false;
    });
}

export function GetChassisStocks(includeZero = false) {
  return getRequest<ChassisStock>(
    `GetChassisStocks?includeZero=${includeZero ? "true" : "false"}`
  );
}

export function GetArmStocks(includeZero = false) {
  return getRequest<ArmStock>(
    `GetArmStocks?includeZero=${includeZero ? "true" : "false"}`
  );
}

export function GetTankStocks(includeZero = false) {
  return getRequest<TankStock>(
    `GetTankStocks?includeZero=${includeZero ? "true" : "false"}`
  );
}

export function UpsertChassisStock(payload: ChassisStockUpsertRequest) {
  return postRequest("UpsertChassisStock", payload);
}

export function UpsertArmStock(payload: ArmStockUpsertRequest) {
  return postRequest("UpsertArmStock", payload);
}

export function UpsertTankStock(payload: TankStockUpsertRequest) {
  return postRequest("UpsertTankStock", payload);
}

export function TransferChassisStock(payload: StockTransferRequest) {
  return postRequest("TransferChassisStock", payload);
}

export function TransferArmStock(payload: StockTransferRequest) {
  return postRequest("TransferArmStock", payload);
}

export function TransferTankStock(payload: StockTransferRequest) {
  return postRequest("TransferTankStock", payload);
}
